export default __webpack_public_path__ + "static/media/bank.b5d1d067.svg";